import axios from 'axios'
import { getAuthToken } from './auth'

export function createApiClient() {
  // Default: usa a API Curem em produção.
  // Você pode sobrescrever com VUE_APP_API_BASE_URL (ex: http://localhost:8000/api)
  const baseURL = process.env.VUE_APP_API_BASE_URL || 'https://api.curem.com.br/api'

  const client = axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
    },
  })

  // Sempre injeta Authorization a partir do token salvo (localStorage).
  client.interceptors.request.use((config) => {
    const token = getAuthToken()
    if (token) {
      config.headers = config.headers || {}
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  })

  return client
}

export const api = createApiClient()

